<template>
  <div id="aprication">
    <div class="header-div">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="header-div" style="text-align: right">
      <el-button v-if="$hasPerm('sys:role:add')" size="mini" @click="handleAdd()" style=";background-color:#16E3A1;color: white">新增<i class="el-icon-plus"></i></el-button>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%;"
      border
      size="medium">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column prop="roleName" label="角色名称" style="width: 35%"></el-table-column>
      <el-table-column prop="remark" label="备注" style="width: 25%"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button v-if="$hasPerm('sys:role:edit')" style="margin-right: 5px;" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑<i class="el-icon-edit"></i></el-button>
          <el-popconfirm title="确定删除吗？" @onConfirm="handleDelete(scope.$index, scope.row)">
            <el-button size="mini" slot="reference" v-if="$hasPerm('sys:role:remove')" type="danger">删除<i class="el-icon-delete"></i></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <edit v-if="editVisible" ref="edit" @handleCurrentChange="handleCurrentChange"></edit>
  </div>
</template>
<script>
  import Edit from './edit'

  export default {
    name: 'RoleList',
    components: {
      Edit
    },
    data() {
      return {
        tableData: [],
        editVisible: false
      }
    },
    methods: {
      handleCurrentChange() {
        this.$httpTAG({
          url: this.$httpTAG.adornUrl('/business/sys/role/list'),
          method: 'get'
        }).then(r => {
          this.tableData = r.data.data;
        }).finally(r => {})
      },
      //时间格式化
      dateFormat: function (row, column) {
        let date = row[column.property];
        /*if(date == 1){return '是'};
        if(date == 0){return '否'};*/
        return date;
      },
      handleAdd() {
        this.editVisible = true;
        this.$nextTick(() => {
          this.$refs.edit.int('',3);
        })
      },
      handleEdit(index, row) {
        let roleId = row.roleId;
        //let name = row.name;
        this.editVisible = true;
        this.$nextTick(() => {
          this.$refs.edit.int(roleId,1);
        })
      },
      handleDelete(index, row) {
        let roleId = row.roleId;

        this.$httpTAG({
          url: this.$httpTAG.adornUrl('/business/sys/role/remove'),
          method: 'post',
          data: this.$httpTAG.adornData({
            'roleId': roleId
          })
        }).then(res => {
          if (res.data.code == 0) {
            this.$notify({
              title: '操作成功！',
              type: 'success',
              offset: 600
            });
            this.handleCurrentChange(1);
          } else {
            this.$message({ // 失败
              type: 'error',
              message: res.data.msg
            })
          }
        }).finally(r => {})

      }
    },
    created: function () {
      this.handleCurrentChange();
    }
  }
</script>
<style scoped>
  .header-div {
    margin-bottom: 5px;
    float: left;
    width: 50%;
  }
</style>
